import { render, staticRenderFns } from "./detail-component-summary.vue?vue&type=template&id=86eae2f2&scoped=true"
import script from "./detail-component-summary.vue?vue&type=script&lang=ts"
export * from "./detail-component-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86eae2f2",
  null
  
)

export default component.exports